import Vue from "vue";
import Vuex from "vuex";

import autenticacao from "./autenticacao.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import overlay from "./overlay.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    autenticacao,
    htmlClass,
    config,
    breadcrumbs,
    overlay,
  },
});
